import { storyblokEditable } from "gatsby-source-storyblok"

import FAQSection from "../../../V2/Sections/Faq"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokFAQSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.FAQSection>) => {
  return (
    <FAQSection
      id={blok.id}
      title={blok.headerText}
      body={blok.bodyText}
      items={blok.faqItems}
      linkColor={blok.ctaColor}
      linkText={blok.ctaText}
      linkUrl={storyblokLinkToYocoLink(blok.ctaLink)}
      backgroundColor={blok.backgroundColor}
      superscript={blok.superscript}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokFAQSection
